module.exports = __webpack_public_path__ + "img/madonna-rebel_heart.7892d933.jpg";